import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"
}), 'ArrowForwardSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowForwardSharp.js
// module id = 2106
// module chunks = 2